if (window.DealCarousel == null) {
  window.DealCarousel = {};
}

DealCarousel.Media = Backbone.Model.extend({
  initialize: function(arg) {
    var ref;
    ref = arg != null ? arg : {}, this.id = ref.id, this.type = ref.type, this.media = ref.media, this.thumb = ref.thumb, this.zoom = ref.zoom, this.provider = ref.provider, this.baseURL = ref.baseURL, this.alt = ref.alt;
    return this.id != null ? this.id : this.id = this.cid;
  },
  isFeatured: function() {
    var ref;
    return ((ref = this.collection) != null ? ref.view.currentFeatured : void 0) === this;
  },
  isLast: function() {
    var ref;
    return ((ref = this.collection) != null ? ref.last() : void 0) === this;
  },
  isVideo: function() {
    return this.type === "video";
  }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9ncm91cG9uLWRlYWwtY2Fyb3VzZWwvZnJvbnRlbmQvbW9kZWxzL21lZGlhLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2FrZXNoYXJpL25hcGlzdHJhbm8vYnVpbGQvMTQ5NTY2MDg5ODI0OS00Mzk2L3Byb2R1Y3Rpb24tMjAxNy4wNS4yNF8yMS4xOS9kZWFsL21vZHVsZXMvZ3JvdXBvbi1kZWFsLWNhcm91c2VsL2Zyb250ZW5kL21vZGVscy9tZWRpYS5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtFQUdBLE1BQU0sQ0FBQyxlQUFnQjs7O0FBRXZCLFlBQVksQ0FBQyxLQUFiLEdBQXFCLFFBQVEsQ0FBQyxLQUFLLENBQUMsTUFBZixDQUVuQjtFQUFBLFVBQUEsRUFBWSxTQUFDLEdBQUQ7QUFDVixRQUFBO3dCQURXLE1BQWlFLElBQWhFLElBQUMsQ0FBQSxTQUFBLElBQUksSUFBQyxDQUFBLFdBQUEsTUFBTSxJQUFDLENBQUEsWUFBQSxPQUFPLElBQUMsQ0FBQSxZQUFBLE9BQU8sSUFBQyxDQUFBLFdBQUEsTUFBTSxJQUFDLENBQUEsZUFBQSxVQUFVLElBQUMsQ0FBQSxjQUFBLFNBQVMsSUFBQyxDQUFBLFVBQUE7NkJBQ3JFLElBQUMsQ0FBQSxLQUFELElBQUMsQ0FBQSxLQUFNLElBQUMsQ0FBQTtFQURFLENBQVo7RUFHQSxVQUFBLEVBQVksU0FBQTtBQUNWLFFBQUE7aURBQVcsQ0FBRSxJQUFJLENBQUMseUJBQWxCLEtBQXFDO0VBRDNCLENBSFo7RUFNQSxNQUFBLEVBQVEsU0FBQTtBQUNOLFFBQUE7aURBQVcsQ0FBRSxJQUFiLENBQUEsV0FBQSxLQUF1QjtFQURqQixDQU5SO0VBU0EsT0FBQSxFQUFTLFNBQUE7V0FDUCxJQUFDLENBQUEsSUFBRCxLQUFTO0VBREYsQ0FUVDtDQUZtQiJ9
